import React, { useState } from "react";
import { withAppLayout } from "../../../hoc";
import WithdrawalRequestContainer from "../../../containers/Distribution/WithdrawalRequestContainer/WithdrawalRequestContainer";
import { ManageDistributionProvider } from "../../../contexts";
import {
  WithDrawalCard,
  EmployeeDetailsCard,
  SliderPanel,
  ConfigureCommunicationField,
} from "../../../components";
import RestOfTheCards from "./RestOfTheCards";
import Table from "../../../components/CsplTable/CsplTable";
const WithdrawalRequest = (props) => {
  const [withdrawalSlider, setWithdrawalSlider] = useState(false);
  const [isExpandable, setIsExpandable] = useState(false);
  const headerData = {
    sourceName: "PreTax",
    availableAmount: "4,500.00",
    grossWithdrawal: "4,520.00",
    tax: "10.00",
    fee: "10.00",
    netWithdrawal: "4,500.00",
  };
  return (
    // <ManageDistributionProvider>
    <WithdrawalRequestContainer {...props} />
    // <>
    //   <div className="m-4">
    //     <WithDrawalCard />
    //     <hr />
    //     <EmployeeDetailsCard />
    //     <hr />
    //     <RestOfTheCards />
    //     <hr />
    //     <DistributionModeSummaryCard />
    //   </div>
    //   <hr />
    //   <div className="mt-5">
    //     <ConfigureCommunicationField data="Add withdrawal allocation" width={"100%"} border="2px dashed #004DCB" padding="10px" borderRadius="5px" isCommunication={false} backgroundColor="rgba(0, 77, 203, 0.1)" onClickNavigate={() => { setWithdrawalSlider(true); }}
    //     />
    // <WithdrawalExpandableCard headerData={headerData} isExpandable={isExpandable} setIsExpandable={setIsExpandable}      >
    //   <div className="p-2 withdrawalbackground">
    //     <SearchComponent />
    //     <span className="ft-12 withdrawalTextColor">6 Records Found</span>
    //   </div>
    //   <div>
    //     <div className="d-flex justify-content-space-between pl-2 pr-2">
    //       <span className="ft-12 withdrawalTextColor">
    //         Investment Name <i className="fas fa-sort"></i>
    //       </span>
    //       <span className="ft-12 withdrawalTextColor">
    //         Available Amount <i className="fas fa-sort"></i>
    //       </span>            <span className="ft-12 withdrawalTextColor">
    //         Nav <i className="fas fa-sort"></i>
    //       </span>
    //       <span className="ft-12 withdrawalTextColor">
    //         Units <i className="fas fa-sort"></i>
    //       </span>
    //       <span className="ft-12 withdrawalTextColor">
    //         Net Withdrawal <i className="fas fa-sort"></i>
    //       </span>
    //     </div>
    //     <Table>
    //       <Table.Tbody>
    //         <Table.Tr>
    //           <Table.Td>ACM 123</Table.Td>
    //           <Table.Td>$ 2500.00</Table.Td>
    //           <Table.Td>$ 55.00</Table.Td>
    //           <Table.Td>$ 55.00</Table.Td>
    //           <Table.Td>$ 2500.00</Table.Td>
    //         </Table.Tr>
    //         <Table.Tr>
    //           <Table.Td>Elapsed Time Comp</Table.Td>
    //           <Table.Td>$ 2500.00</Table.Td>
    //           <Table.Td>$ 55.00</Table.Td>

    //           <Table.Td>$ 55.00</Table.Td>

    //           <Table.Td>$ 2500.00</Table.Td>
    //         </Table.Tr>
    //         <Table.Tr>
    //           <Table.Td>ACM 123</Table.Td>
    //           <Table.Td>$ 2500.00</Table.Td>
    //           <Table.Td>$ 55.00</Table.Td>

    //           <Table.Td>$ 55.00</Table.Td>
    //           <Table.Td>$ 2500.00</Table.Td>
    //         </Table.Tr>

    //         <Table.Tr>
    //           <Table.Td>Elapsed Time Comp</Table.Td>
    //           <Table.Td>$ 2500.00</Table.Td>
    //           <Table.Td>$ 55.00</Table.Td>
    //           <Table.Td>$ 55.00</Table.Td>
    //           <Table.Td>$ 2500.00</Table.Td>
    //         </Table.Tr>
    //       </Table.Tbody>
    //     </Table>
    //   </div>
    // </WithdrawalExpandableCard >
    //     <SliderPanel isOpen={withdrawalSlider} size="60"
    //       onClose={() => { setWithdrawalSlider(false); }}
    //       backdropClicked={() => { setWithdrawalSlider(false); }}
    //       showCancel={false} showBackButton={false}
    //       showCancelButton={true} showSave={true}      >
    //       <h5>Add Withdrawal Allocation</h5>
    //     </SliderPanel>
    //   </div >
    // </>
  );
};

export default WithdrawalRequest;
